import { render, staticRenderFns } from "./NumberInputComponent.vue?vue&type=template&id=a4210718&lang=pug"
import script from "./NumberInputComponent.vue?vue&type=script&lang=js"
export * from "./NumberInputComponent.vue?vue&type=script&lang=js"
import style0 from "./NumberInputComponent.vue?vue&type=style&index=0&id=a4210718&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports